import { toast } from "react-toastify"; 

export const showSuccessToast = (message: string) => {
    toast( message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "colored",
        type: "success"
    });
}

export const showErrorToast = (message: string) => {
    toast( message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "colored",
        type: "error"
    });
}